import { render, staticRenderFns } from "./DataTouchpoints.vue?vue&type=template&id=21296fc0&"
import script from "./DataTouchpoints.vue?vue&type=script&lang=js&"
export * from "./DataTouchpoints.vue?vue&type=script&lang=js&"
import style0 from "./DataTouchpoints.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21296fc0')) {
      api.createRecord('21296fc0', component.options)
    } else {
      api.reload('21296fc0', component.options)
    }
    module.hot.accept("./DataTouchpoints.vue?vue&type=template&id=21296fc0&", function () {
      api.rerender('21296fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/DataTouchpoints.vue"
export default component.exports